module.exports = __webpack_public_path__ + "static/media/inktoberFolliage.3216fc04.gif";